import useProfileImage from "@/hooks/useProfileImage";
import { UPLOAD_SKIPPED } from "constants/general";
import { routes } from "constants/routes";
import { getFromLocalStorage } from "core/utils/utils.helper";
import useAuth from "hooks/useAuth";
import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useUserInfoStore } from "@/stores/userInfoStore";

// Define the types for the props
interface RedirectWrapperProps {
  children?: ReactNode; // Optional children prop, which can accept any valid JSX elements
}

export const RedirectWrapper: React.FC<RedirectWrapperProps> = ({
  children,
}) => {
  const upload_skipped = getFromLocalStorage(UPLOAD_SKIPPED); //get image upload skipped value from local storage

  const userData = useUserInfoStore((s) => s.userInfo); // get profile data from zustand persist
  const auth: any = useAuth();
  const { profileImageUrl } = useProfileImage();

  if (auth && auth.isAuthenticated) {
    if (!userData?.firstName) {
      return (
        <Navigate
          to={`${routes.profile.path}/${routes.registrationFlow.path}`}
          replace
        />
      );
    } else if (
      !userData?.image_path &&
      !profileImageUrl &&
      upload_skipped === null
    ) {
      return (
        <Navigate
          to={`${routes.profile.path}/${routes.imageUpload.path}`}
          replace
        />
      );
    } else {
      return <>{children}</>;
    }
  } else {
    return <>{children}</>;
  }
};
